import { render, staticRenderFns } from "./MultiClaimNoHelpList.vue?vue&type=template&id=5a9886fe&"
import script from "./MultiClaimNoHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiClaimNoHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports